export const checkAllStatusesAreEqual = (statuses: Array<string>) =>
  statuses.every((val, _i, arr) => arr.length > 0 && val === arr[0]);
